import React, { Component } from "react";
import { FormValidate } from "../../../../../components/formValidate";
import CustomButton from "../../../../../components/inputs/button";
import CheckBox from "../../../../../components/inputs/checkbox";
import TextField from "../../../../../components/inputs/textfield";
import Snackbar from "../../../../../components/snackbar/snackbar";
import { admin_tender_add, admin_tender_update } from "../../../admin.api";
import "./dialog.css";
import CommonForm from "../../../../../components/commonform/commonForm";
import DatePickerField from "../../../../../components/inputs/datepicker";
import moment from "moment";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import TextEditer from "../../../../../components/inputs/texteditor";
import { useState } from "react";

class Dialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      formData: props.formData,
      edit: props.edit,
      submitted: false,
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
      fileError: false,
      fileChange: false,
      dropcatdata: props.dropcatdata,
      droporgdata: props.droporgdata,
    };
  }

  componentWillReceiveProps = (props) => {
    this.setState({
      open: props.open,
      edit: props.edit,
      formData: props.formData,
      dropcatdata: props.dropcatdata,
      droporgdata: props.droporgdata,
    });
  };

  handleChange = (e) => {
    const { name, value } = e.target;

    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value,
      },
    }));
  };
  handleDatePickerChange = (e, name) => {
    let date = e.value;
    if (date) {
      this.setState({
        formData: {
          ...this.state.formData,
          [name]: date,
        },
      });
    } else {
      this.setState({
        formData: {
          ...this.state.formData,
          [name]: null,
        },
      });
    }
  };
  handleCheckChange = (e) => {
    let checked = e.target.checked;
    let name = e.target.name;

    if (checked) {
      this.setState({
        formData: { ...this.state.formData, tender_publish_status: 1 },
      });
    } else {
      this.setState({
        formData: { ...this.state.formData, tender_publish_status: 0 },
      });
    }
  };
  handleEditorChange = (value, fieldName) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [fieldName]: value,
      },
    });
  };
  snackbarClose = (flag) => {
    this.setState({
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
    });
    if (!flag) {
      this.props.handleClose();
    }
  };

  handleSubmit = (e) => {
    const { edit, formData, fileError, fileChange } = this.state;
    this.setState({
      submitted: true,
    });

    let required = [
      "tender_title",
      "title_ma",
      // "organized_by",
      // "organized_by_ma",
      "description",
      "description_ma",
      ...(formData.link ? ["link"] : ["file", "file_name"]),
      "organisation",
      ...(formData.organisation ? ["organisation"] : ["other_organization"]),
      "category",
      ...(formData.category ? ["category"] : ["other_category"]),
    ];
    const error = FormValidate(this.state.formData, required);
    const parseErrorMessage = (error) => {
      if (error?.response?.data?.error) {
        return Object.values(error.response.data.error).flat().join(", ");
      }
      if (error?.response?.data?.message) {
        return error.response.data.message;
      }
      return error?.message || "Something went wrong";
    };

    e.preventDefault();
    if (formData.organisation === "0" || formData.organisation === 0) {
      this.setState({
        submitted: false,
        snackMessage: "Please select a valid Organisation",
        isSnackError: true,
        snackOpen: true,
      });
      return;
    }
    if (formData.category === "0" || formData.category === 0) {
      this.setState({
        submitted: false,
        snackMessage: "Please select a valid Category",
        isSnackError: true,
        snackOpen: true,
      });
      return;
    }
    let payload = new FormData();
    if (!formData?.value_of_tender || formData?.value_of_tender === "") {
      payload.append("value_of_tender", 0);
    }
    Object.keys(formData).forEach((key) => {
      if (key === "file" && fileChange) {
        if (formData.file) {
          payload.append("file", formData?.file);
        }
      } else if (key === "file_name") {
        if (formData.file) {
          payload.append("file_name", formData?.file_name);
        }
      } else if (key === "link") {
        if (formData.link) {
          payload.append("link", formData?.link);
        }
      } else if (key === "organisation") {
        payload.append(
          "organisation",
          formData.organisation === "Others"
            ? formData?.other_organization
            : formData?.organisation
        );
      } else if (key === "category") {
        payload.append(
          "category",
          formData.category === "Others"
            ? formData?.other_category
            : formData?.category
        );
      } else if (key === "due_date") {
        payload.append(
          "due_date",
          formData?.due_date
            ? moment(formData?.due_date, "DD-MM-YYYY HH:mm").format(
                "YYYY-MM-DD HH:mm"
              )
            : ""
        );
      } else if (key !== "file") {
        payload.append(key, formData[key]);
      }
      payload.append("type", "private");
    });
    if (Object.keys(error).length === 0 && !fileError) {
      payload.append("tender_publish_status", 1);

      if (edit) {
        admin_tender_update(formData.id, payload)
          .then((res) => {
            this.setState({
              snackMessage: "Trade enquiry updated successfully",
              isSnackError: false,
              snackOpen: true,
            });
          })
          .catch((error) => {
            const message = parseErrorMessage(error);

            this.setState({
              snackMessage: message,
              isSnackError: true,
              snackOpen: true,
            });
          })

          .finally(() => {
            this.setState({
              submitted: false,
            });
          });
      } else {
        admin_tender_add(payload)
          .then((res) => {
            this.setState({
              submitted: true,
              snackMessage: "Trade enquiry created successfully",
              isSnackError: false,
              snackOpen: true,
            });
          })
          .catch((error) => {
            this.setState({
              submitted: false,
              snackMessage: error.message,
              isSnackError: true,
              snackOpen: true,
            });
          });
      }
    } else {
      this.setState({
        submitted: false,
        snackMessage: "Please fill all mandatory fields",
        isSnackError: true,
        snackOpen: true,
      });
    }
  };
  handleSelect = (e) => {
    this.setState({
      formData: {
        ...this.state.formData,
        parent_id: e.target.value,
      },
    });
  };

  handleFileChange = (e) => {
    let size = e.target.files[0].size;
    let type = e.target.files[0].name.split(".").pop();

    if (
      type?.toLowerCase() === "pdf" ||
      type?.toLowerCase() === "doc" ||
      type?.toLowerCase() === "docx"
    ) {
      let mb = size / Math.pow(1024, 2);

      if (mb < 5) {
        this.setState({ fileChange: true });
        this.setState({ fileError: false });
        this.setState({
          formData: {
            ...this.state.formData,
            file: e.target.files[0],
            file_name: e.target.files[0].name,
          },
        });
      } else {
        this.setState({ fileError: true });
        this.setState({
          formData: { ...this.state.formData, file: null, file_name: null },
        });
      }
    } else {
      this.setState({ fileError: true });
      this.setState({
        formData: { ...this.state.formData, file: null, file_name: null },
      });
    }
  };

  render() {
    const { submitted, formData, open, edit, droporgdata, dropcatdata } =
      this.state;
    const { view } = this.props;
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate());
    return (
      <React.Fragment>
        {open && (
          <React.Fragment>
            <div className="overlay">
              <div className="big-dia-tender-admin2">
                <Snackbar
                  message={this.state.snackMessage}
                  error={this.state.isSnackError}
                  open={this.state.snackOpen}
                  close={this.snackbarClose}
                />
                <div className="d-flex flex-column">
                  <div className="">
                    <div className="flexDisplay">
                      <div className="diaTitleCon">
                        {edit
                          ? "Edit Trade Enquiry"
                          : view
                          ? "Trade Enquiry"
                          : "Add Trade Enquiry"}
                      </div>
                      <div
                        className="dia-close"
                        onClick={this.props.handleClose}
                      >
                        <div className="diaCloseCon">
                          <div className="diaClose">&#10005;</div>
                        </div>
                      </div>
                    </div>

                    <div className="tilebars">
                      <hr />
                    </div>
                  </div>
                  <form action="">
                    <div className="row book-form">
                      <div className="content-scroll-xx2">
                        <div className="col-12">
                          <TextField
                            view="straight"
                            id="outlined-basic"
                            label="Tender ID[Eng]"
                            variant="outlined"
                            disabled={view}
                            onChange={(e) => this.handleChange(e)}
                            value={formData?.tender_title ?? ""}
                            name="tender_title"
                            required
                          />
                        </div>
                        <div className="col-12 ">
                          <TextField
                            view="straight"
                            id="outlined-basic"
                            label="Tender ID[Mal]"
                            variant="outlined"
                            disabled={view}
                            onChange={(e) => this.handleChange(e)}
                            value={formData?.title_ma ?? ""}
                            name="title_ma"
                            required
                          />
                        </div>
                        <div className="col-12 ">
                          <TextField
                            view="straight"
                            id="outlined-basic"
                            label="Reference Number"
                            variant="outlined"
                            disabled={view}
                            onChange={(e) => this.handleChange(e)}
                            value={formData?.ref_no ?? ""}
                            name="ref_no"
                            // required
                          />
                        </div>
                        <div className="row">
                          <div className=" col-3 organization">
                            Organization
                          </div>
                          <div className="col-9 pb-2">
                            <select
                              className="form-select newSelectbox mandatory-select "
                              required
                              name="organisation"
                              value={formData?.organisation}
                              onChange={(e) => this.handleChange(e)}
                              disabled={view}
                            >
                              <option value={0}>Select Organisation</option>

                              {droporgdata?.map((item) => (
                                <option key={item.id} value={item.name}>
                                  {item.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          {formData?.organisation === "Others" && (
                            <>
                              <div className=" col-3 organization pb-2">
                                Specify Your Organization
                              </div>

                              <div className="col-9 ">
                                <TextField
                                  fullwidth
                                  required
                                  value={formData?.other_organization ?? ""}
                                  onChange={(e) => this.handleChange(e)}
                                  name="other_organization"
                                  id="other_organization"
                                  aria-describedby="emailHelp"
                                  disabled={view}
                                />
                              </div>
                            </>
                          )}
                        </div>
                        <div className="row">
                          <div className=" col-3 category">Categories</div>

                          <div className="col-9 pb-2">
                            <select
                              className="form-select newSelectbox mandatory-select "
                              required
                              name="category"
                              value={formData?.category}
                              onChange={(e) => this.handleChange(e)}
                              disabled={view}
                            >
                              <option value={0}>Select Category</option>
                              {dropcatdata?.map((item) => (
                                <option key={item.id} value={item.name}>
                                  {item.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          {formData?.category === "Others" && (
                            <>
                              <div className=" col-3 category">
                                Specify Your Category
                              </div>

                              <div className="col-9 pb-2">
                                <TextField
                                  fullwidth
                                  required
                                  value={formData?.other_category ?? ""}
                                  onChange={(e) => this.handleChange(e)}
                                  name="other_category"
                                  id="other_category"
                                  aria-describedby="emailHelp"
                                />
                              </div>
                            </>
                          )}
                        </div>
                        <div className="col-12">
                          <label className="mylabel">Description[Eng]</label>
                          <TextEditer
                            value={formData?.description ?? ""}
                            onChange={(e) =>
                              this.handleEditorChange(e, "description")
                            }
                            disabled={view}
                            name="description"
                            required
                          />
                        </div>
                        <div className="col-12">
                          <label className="mylabel">Description[Mal]</label>
                          <TextEditer
                            value={formData?.description_ma ?? ""}
                            onChange={(e) =>
                              this.handleEditorChange(e, "description_ma")
                            }
                            disabled={view}
                            name="description_ma"
                            required
                          />
                        </div>

                        <div className="d-flex justify-content-between align-items-center">
                          <div className="">Due Date</div>
                          <div className="col-9 ">
                            <DatePickerField
                              // required
                              value={formData?.due_date ?? undefined}
                              minDate={tomorrow}
                              disabled={view}
                              // label="Due Date"
                              // required
                              format="DD-MM-YYYY HH:mm"
                              plugins={[<TimePicker hideSeconds />]}
                              onChange={(e) =>
                                this.handleDatePickerChange(e, "due_date")
                              }
                            />
                          </div>
                        </div>
                        {/* <div className="col-12 ">
                          <TextField
                            view="straight"
                            id="outlined-basic"
                            label="Organized by[Eng]"
                            name="organized_by"
                            variant="outlined"
                            disabled={view}
                            value={formData?.organized_by ?? ""}
                            onChange={(e) => this.handleChange(e)}
                            required
                          />
                        </div>
                        <div className="col-12 ">
                          <TextField
                            view="straight"
                            id="outlined-basic"
                            label="Organized by[Mal]"
                            name="organized_by_ma"
                            variant="outlined"
                            disabled={view}
                            value={formData?.organized_by_ma ?? ""}
                            onChange={(e) => this.handleChange(e)}
                            required
                          />
                        </div> */}

                        <div className="col-12 ">
                          <TextField
                            view="straight"
                            id="outlined-basic"
                            name="value_of_tender"
                            onChange={(e) => this.handleChange(e)}
                            label="Tender Value"
                            disabled={view}
                            value={formData?.value_of_tender ?? ""}
                            variant="outlined"
                            type="number"
                            // required
                          />
                        </div>
                        
                        <div className="col-12">
                          <TextField
                            view="straight"
                            id="outlined-basic"
                            name="link"
                            onChange={(e) => this.handleChange(e)}
                            label="Link"
                            disabled={view}
                            max="20"
                            value={formData?.link ?? ""}
                            variant="outlined"
                            // required
                          />
                        </div>

                        <div className="col-12">
                          <TextField
                            type="file"
                            view="straight"
                            id="outlined-basic"
                            onChange={(e) => this.handleFileChange(e)}
                            label="File"
                            disabled={view}
                            fileName={formData?.file_name}
                            accept=".pdf,.docx,.doc"
                            // required
                          />
                          {this.state.fileError && (
                            <div className="file-up-helper text-center">
                              *Upload only .pdf , .doc, .docx and Size should be
                              less than 1MB
                            </div>
                          )}
                        </div>
                      </div>
                      {!view && (
                        <div className="col-12">
                          <CustomButton
                            label={edit ? "Update" : "Add"}
                            disabled={submitted}
                            onClick={(e) => this.handleSubmit(e)}
                          />
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default Dialog;
